// @flow
/* eslint-env browser */
import { analyticsActions, AsyncRequest } from 'angieslist-app-platform';
import { combineReducers } from 'redux';
import { defaultProps } from '../../../app/browser/analyticsDefaultProperties';
import reviewsActionKeys from './reviewsActionKeys';
import reviewsActions from './reviewsActions';
import type { GetReviewsRequest, GetReviewCategoriesRequest, GetReviewCategoriesResponse, CreateOrUpdateRetortRequest, CreateOrUpdateRetortResponse } from './reviewsService';
import type { AsyncState, Reviews } from '../types';

export type ReviewsReducerState = {
  reviews: AsyncState<GetReviewsRequest, {
    reviews: Reviews[], totalReviewCount: number }>,
  reviewCategories: AsyncState<GetReviewCategoriesRequest, GetReviewCategoriesResponse>,
  retort: AsyncState<CreateOrUpdateRetortRequest, CreateOrUpdateRetortResponse>,
};

export default (combineReducers({
  reviews: AsyncRequest.createReducer(reviewsActionKeys.GET_REVIEWS, {
    [reviewsActionKeys.CREATE_OR_UPDATE_RETORT_SUCCESS]: (state, action) => {
      const { reviewId } = action.payload.body;
      action.addSideEffect((store) => {
        store.dispatch(analyticsActions.sendEnhancedTrackEvent({
          name: 'Store Page - Review Tab - Retort Edit Saved',
          properties: {
            ...defaultProps,
            userType: 'Authenticated',
            eventType: 'control',
            ReviewId: reviewId,
          },
        }));
      });
      const reviewIndex = state.getIn(['response', 'reviews']).findIndex(review => review.getIn(['reviewId']) === +reviewId);
      return state.setIn(['response', 'reviews', reviewIndex, 'retort'], { ...action.payload.body, text: { display: action.payload.body.text } });
    },
    [reviewsActionKeys.GET_REVIEWS_SUCCESS]: (state, action) => {
      const { markReviewsRead } = action.meta;
      const { reviews } = action.payload.body;
      const [firstReview] = reviews;
      if (markReviewsRead && firstReview) {
        action.addSideEffect((store) => {
          store.dispatch(reviewsActions.markReviewsRead(
            state.getIn(['request', 'serviceProviderId']),
            firstReview.reviewId,
          ));
        });
      }
      return AsyncRequest.setSuccess(state, action.payload.body);
    },
  }),
  reviewCategories: AsyncRequest.createReducer(reviewsActionKeys.GET_REVIEW_CATEGORIES),
  retort: AsyncRequest.createReducer(reviewsActionKeys.CREATE_OR_UPDATE_RETORT),
}): any);



// WEBPACK FOOTER //
// ./src/modules/store/common/reviewsReducer.js